export const XMASBACKGROUND = [
  {
    desktop: '../../assets/imgs/syncIndicatorBackgrounds/desktop/xmas1.png',
    mobile: '../../assets/imgs/syncIndicatorBackgrounds/mobile/xmas1.png',
  },
];
